var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart1 = function SvgHeart1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 114
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M65.3 113.341V13.902a36.2 36.2 0 0 0-10.74-9.077A37.2 37.2 0 0 0 40.34.354a37.4 37.4 0 0 0-14.87 1.452 36.8 36.8 0 0 0-13.023 7.132A35.6 35.6 0 0 0 3.46 20.552 34.7 34.7 0 0 0 .013 34.698a34.6 34.6 0 0 0 2.675 14.303 35.4 35.4 0 0 0 8.348 12.058z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M65.3 113.34V13.902a36.2 36.2 0 0 1 10.74-9.077A37.2 37.2 0 0 1 90.26.354a37.4 37.4 0 0 1 14.87 1.452 36.8 36.8 0 0 1 13.023 7.132 35.6 35.6 0 0 1 8.988 11.614 34.7 34.7 0 0 1 3.446 14.146 34.6 34.6 0 0 1-2.675 14.303 35.4 35.4 0 0 1-8.348 12.058z",
    clipRule: "evenodd"
  })));
};
export default SvgHeart1;